import apiPaths from '../api-paths';

export default {
  list() {
    return axios.get(`${ apiPaths.STAFF }/partner-staffs?list=true`);
  },
  listByCrmOriginal({ crmOriginal }) {
    return axios.get(`${ apiPaths.STAFF }/partner-staffs/by-crm-original/${ crmOriginal }`);
  },
  show({ id }) {
    return axios.get(`${ apiPaths.STAFF }/partner-staffs/${ id }`);
  },
  store({ data }) {
    return axios.post(`${ apiPaths.STAFF }/partner-staffs`, { partnerstaff: data });
  },
  update({ data }) {
    return axios.put(`${ apiPaths.STAFF }/partner-staffs/${ data.id }`, { partnerstaff: data });
  },
  downstream: {
    index({ query }) {
      return axios.get(`${ apiPaths.DOWNSTREAM.STAFF }/partner-staffs${ query }`);
    },
    show({ id, query }) {
      return axios.get(`${ apiPaths.DOWNSTREAM.STAFF }/partner-staffs/${ id }${ query }`);
    },
    store({ data, crmOriginal }) {
      return axios.post(`${ apiPaths.DOWNSTREAM.STAFF }/partner-staffs`, { partnerstaff: data, crmOriginal });
    },
    update({ data, crmOriginal }) {
      return axios.put(`${ apiPaths.DOWNSTREAM.STAFF }/partner-staffs/${ data.id }`, { partnerstaff: data, crmOriginal });
    },
    destroy({ id, query }) {
      return axios.delete(`${ apiPaths.DOWNSTREAM.STAFF }/partner-staffs/${ id }${ query }`);
    },
  },
};
